import { render, staticRenderFns } from "./JupyterIframe.vue?vue&type=template&id=aaf50636&scoped=true&"
import script from "./JupyterIframe.vue?vue&type=script&lang=ts&"
export * from "./JupyterIframe.vue?vue&type=script&lang=ts&"
import style0 from "./JupyterIframe.vue?vue&type=style&index=0&id=aaf50636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf50636",
  null
  
)

export default component.exports